/**
 * Elilhaam — Card size chips (live, cache-safe)
 * 
 * Each product card embeds a compact variant JSON in .card-sizes .card-sizes-data
 * This script reads it and renders only truly in-stock sizes.
 * Runs after DOM load — no Shopify cache dependency.
 */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.card-sizes[data-opt-pos]').forEach(function(el) {
    var dataScript = el.querySelector('.card-sizes-data');
    if (!dataScript) return;

    var variants, optPos;
    try {
      variants = JSON.parse(dataScript.textContent);
      optPos   = parseInt(el.dataset.optPos) || 0;
    } catch(e) { el.style.display = 'none'; return; }

    // Compute truly in-stock sizes using live inventory data
    var seen  = {};
    var stock = [];
    variants.forEach(function(v) {
      var isStock = false;
      if (v.u) {
        isStock = true; // unstitched
      } else if (v.mgmt === null || v.mgmt === undefined) {
        isStock = v.avail; // no inventory management
      } else if (v.qty > 0) {
        isStock = true; // has stock
      }
      if (!isStock) return;
      var sz = Array.isArray(v.o) ? v.o[optPos] : null;
      if (sz && !seen[sz]) { seen[sz] = true; stock.push(sz); }
    });

    if (!stock.length) { el.style.display = 'none'; return; }

    // Build the chip strip
    var show = stock.slice(0, 4);
    var more = stock.length - show.length;

    var inner = document.createElement('div');
    inner.className = 'card-sizes__inner';

    var lbl = document.createElement('span');
    lbl.className = 'card-sizes__label';
    lbl.textContent = 'In Stock:';
    inner.appendChild(lbl);

    show.forEach(function(sz) {
      var chip = document.createElement('span');
      chip.className = 'card-sizes__chip';
      chip.textContent = sz;
      inner.appendChild(chip);
    });

    if (more > 0) {
      var m = document.createElement('span');
      m.className = 'card-sizes__more';
      m.textContent = '+' + more;
      inner.appendChild(m);
    }

    // Clear old Liquid-rendered chips and insert live chips
    dataScript.remove();
    el.innerHTML = '';
    el.appendChild(inner);
  });
});
